import React, { useState } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./singleeventimageslider.module.scss";
import { getDefaultImage } from "../../utils/GeneralUtils";

type Props = {
  img?: Array<string>;
};
const SingleEventImageSlider: React.FC<Props> = ({ img }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const setSlideClass = (i: number) => {
    if (img) {
      switch (activeIndex) {
        case i:
          return `${styles["swiper-slide"]} ${styles["active"]}`;
        case i + 1:
        case i - 1:
          return `${styles["swiper-slide"]} ${styles["adjacent"]}`;
        case 0:
          if (i === img.length - 1) {
            return `${styles["swiper-slide"]} ${styles["adjacent"]}`;
          } else {
            return `${styles["swiper-slide"]}`;
          }
        case img.length - 1:
          if (i === 0) {
            return `${styles["swiper-slide"]} ${styles["adjacent"]}`;
          } else {
            return `${styles["swiper-slide"]}`;
          }
        default:
          return `${styles["swiper-slide"]}`;
      }
    }
  };

  return (
    <div className={styles["eventimageslider"]}>
      <Swiper
        modules={[Navigation, Pagination]}
        className={styles["eventimageslider_swiper"]}
        slidesPerView={"auto"}
        breakpoints={{
          768: { slidesPerView: "auto" },
        }}
        centeredSlides={true}
        loop={img && img?.length <= 1 ? false : true}
        onActiveIndexChange={(swiper) => setActiveIndex(swiper.realIndex)}
        pagination={{
          el: `.${styles["pagination"]}`,
          bulletClass: `${styles["swiper-pagination-bullet"]}`,
          bulletActiveClass: `${styles["active"]}`,
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + "</span>";
          },
        }}
        navigation={{
          prevEl: `.${styles["prev"]}`,
          nextEl: `.${styles["next"]}`,
          disabledClass: `${styles["disabled"]}`,
        }}
      >
        {img && img.length > 0 ? (
          img.map((value, index) => {
            return (
              <SwiperSlide className={setSlideClass(index)} key={index}>
                <div className={styles["swiper-slide_item"]}>
                  <img
                    src={value}
                    className={styles["swiper-slide_item_img"]}
                  />
                </div>
              </SwiperSlide>
            );
          })
        ) : (
          <SwiperSlide className={setSlideClass(0)}>
            <div className={styles["swiper-slide_item"]}>
              <img
                src={getDefaultImage()}
                className={styles["swiper-slide_item_img"]}
              />
            </div>
          </SwiperSlide>
        )}
      </Swiper>
      <div className={`${styles["eventimageslider-btn"]} ${styles["prev"]}`}>
        <div className={styles["eventimageslider-box"]}>
          <FontAwesomeIcon icon={["fal", "long-arrow-left"]} />
        </div>
      </div>
      <div className={`${styles["eventimageslider-btn"]} ${styles["next"]}`}>
        <div className={styles["eventimageslider-box"]}>
          <FontAwesomeIcon icon={["fal", "long-arrow-right"]} />
        </div>
      </div>
      <div className={styles["pagination"]}></div>
    </div>
  );
};

export default SingleEventImageSlider;
